"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var native_base_1 = require("native-base");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var busy_overlay_style_1 = require("../../../../theming/pricing-system/busy-overlay.style");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var BusyOverlay = function (_super) {
  __extends(BusyOverlay, _super);

  function BusyOverlay() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  BusyOverlay.prototype.render = function () {
    if (!this.props.showBusy) {
      return null;
    }

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.busyOverlayViewStyle,
      pointerEvents: "none"
    }), react_1.default.createElement(native_base_1.Spinner, {
      color: busy_overlay_style_1.busyOverlaySpinnerColor,
      style: theme_pricing_system_1.pricingStyles.busyOverlaySpinnerViewStyle
    }));
  };

  return BusyOverlay;
}(react_1.default.Component);

exports.BusyOverlay = BusyOverlay;